module.exports = __webpack_public_path__ + "img/camera-active.d5928064.svg";